// BEUS-11496 M3: 신규(v2) 경로 안내 상태. 화면 패널(kind)마다 마지막 조회 결과만 남기고, 안내는 그 합으로 정한다.
// 패널마다 따로 덮어쓰므로 옵션을 바꿔 한 패널만 다시 불러도 다른 패널의 지난 상태가 남지 않는다(reset 불필요).
//
// - clippedAt: 오늘 날짜처럼 끝 시각을 공개 범위(watermark)로 자른 경우 그 시각(ISO). P0 #8.
// - legacyFilter: CTA·방문 빈도 조건이라 기존 API로 조회한 경우. P0 D7 임시 C안(신규 집계에 없는 필터, 안내).
//   M3 동안은 기존 API로 값을 보여 주고 안내만 한다. 기존 API를 끄는 M4 전에 문구·동작(필터 비활성)을 다시 정한다.

export const LEGACY_FILTER_REASONS = ['cta', 'frequency']

// kind: 'scroll' | 'basicInfo' | 'hourBasicInfo' | 'fold' | 'heatmap'
// outcome: { clippedAt?: string|null, reason?: string|null }
export function updateNotice (state, kind, outcome = {}) {
  return {
    ...state,
    [kind]: {
      clippedAt: outcome.clippedAt || null,
      legacyFilter: LEGACY_FILTER_REASONS.includes(outcome.reason)
    }
  }
}

export function summarizeNotice (state) {
  let clippedAt = null
  let legacyFilter = false
  for (const s of Object.values(state || {})) {
    if (s.clippedAt && (!clippedAt || new Date(s.clippedAt) < new Date(clippedAt))) clippedAt = s.clippedAt
    if (s.legacyFilter) legacyFilter = true
  }
  return { clippedAt, legacyFilter }
}

function pad (n) {
  return String(n).padStart(2, '0')
}

// ISO 시각 -> apply timezone offset('+09:00') 기준 'YYYY-MM-DD HH:mm'. offset을 읽지 못하면 +09:00.
export function formatNoticeTime (iso, tzOffset = '+09:00') {
  const m = /^([+-])(\d{2}):?(\d{2})$/.exec(tzOffset || '')
  const minutes = m ? (m[1] === '-' ? -1 : 1) * (Number(m[2]) * 60 + Number(m[3])) : 9 * 60
  const t = new Date(new Date(iso).getTime() + minutes * 60000)
  return `${t.getUTCFullYear()}-${pad(t.getUTCMonth() + 1)}-${pad(t.getUTCDate())} ` +
    `${pad(t.getUTCHours())}:${pad(t.getUTCMinutes())}`
}
